import jQuery from "jquery"
import 'jquery-smooth-scroll'

export default class BackToTop {
    constructor () {
        const BackToTop = jQuery('.back-to-top')
        if (BackToTop) {
            BackToTop.on('click', function(e)  {
                e.preventDefault()
                jQuery.smoothScroll({
                    scrollTop: 0,
                    speed:1000
                  });
                return false;
            })
        }
        return
    }
}
